import { render, staticRenderFns } from "./langSwitcherItem.vue?vue&type=template&id=75fd4dc8&scoped=true&lang=pug&"
import script from "./langSwitcherItem.vue?vue&type=script&lang=ts&"
export * from "./langSwitcherItem.vue?vue&type=script&lang=ts&"
import style0 from "./langSwitcherItem.vue?vue&type=style&index=0&id=75fd4dc8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75fd4dc8",
  null
  
)

export default component.exports